import { render, staticRenderFns } from "./InspectionForm.vue?vue&type=template&id=522c7bf4"
import script from "./InspectionForm.vue?vue&type=script&lang=js"
export * from "./InspectionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports